//import axios from "axios";

import AppAxios, { Headers } from "../../../axios";

export const MASTER_URL = "/MemberMaster";
export const IndustryType_URL = "/LovServices/GetIndustryTypeLov";
export const IndustryCluster_URL =
  "/LovServices/GetIndustryClusterMaster_WRTO_BT";
export const BusinessType_URL = "/BusinessType";
export const City_URL = "/LovServices/GetCities";
export const City_URL1 = "/LovServices/GetStateByCountry";
export const Country_URL = "/Country";
export const UPDATE_PERSONA = "/UserDetail";
export const UPDATE_MEMBER = "persona";
export const UPDATE_MASTER = "/MemberMaster/GetMemberMasterById";

// CREATE =>  POST: add a new master to the server
export function createmaster(master) {
  return AppAxios.post(MASTER_URL, master, { headers: Headers() });
}
export function putmaster(master) {
  return AppAxios.put(MASTER_URL, master, { headers: Headers() });
}
export function getmaster(masterId) {
  return AppAxios.get(`${UPDATE_MASTER}`, {
    headers: Headers(masterId),
  });
}
export function membermaster(master) {
  return AppAxios.post(MASTER_URL, master, { headers: Headers() });
}

export function updatepersona(master) {
  return AppAxios.post(UPDATE_PERSONA, master, { headers: Headers() });
}

// READ
export function getAllmasters() {
  return AppAxios.get(MASTER_URL, { headers: Headers() });
}
export function fetchIndustryType() {
  return AppAxios.get(IndustryType_URL, { headers: Headers() });
}
export function fetchIndustryCluster(id) {
  return AppAxios.get(IndustryCluster_URL + `?BT_ID=${id}`, {
    headers: Headers(),
  });
}

export function fetchBusinessType() {
  return AppAxios.get(BusinessType_URL, { headers: Headers() });
}
export function fetchCities(c_id) {
  console.log(c_id,"axios")
  return AppAxios.get(`${City_URL}?CNT_Id=${c_id}`, { headers: Headers() });
}

export function fetchStates(c_id) {
  console.log(c_id,"axios")
  return AppAxios.get(`${City_URL1}?CNT_Id=${c_id}`, { headers: Headers() });
}
export function fetchCountry() {
  return AppAxios.get(Country_URL, { headers: Headers() });
}

export function getmasterById(masterId) {
  return AppAxios.get(`${MASTER_URL}/GetMemberMasterById`, {
    headers: Headers(masterId),
  });
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findmasters(queryParams) {
  if (queryParams) {
    return AppAxios.get(`${MASTER_URL}/GetMemberMasterById`, {
      headers: Headers(queryParams),
    });
  } else {
    return AppAxios.get(MASTER_URL, { headers: Headers() });
  }
  //return AppAxios.post(`${MASTER_URL}/find`, { queryParams });
}

// UPDATE => PUT: update the master on the server
export function updatemaster(master) {
  return AppAxios.put(`${MASTER_URL}`, master, { headers: Headers() });
}

// UPDATE Status
export function updateStatusFormasters(ids, status) {
  return AppAxios.post(`${MASTER_URL}/updateStatusFormasters`, {
    ids,
    status,
  });
}

// DELETE => delete the master from the server
export function deletemaster(masterId) {
  return AppAxios.delete(`${MASTER_URL}`, { headers: Headers(masterId) });
}

// DELETE masters by ids
export function deletemasters(ids) {
  return AppAxios.post(`${MASTER_URL}/deletemasters`, { ids });
}
